import { Group, Text } from "@/components/ui";
import type { ProveedorCatalogo } from "@/lib/types";

interface Props {
  proveedor: ProveedorCatalogo;
  seleccionado: boolean;
  onClick: () => void;
}

/**
 * Botón-tarjeta para un proveedor candidato · presentacional.
 * El estado de selección se controla por el padre · este componente
 * solo refleja el flag visualmente y dispara `onClick`.
 */
export function CandidatoButton({ proveedor, seleccionado, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-lg border p-3 text-left transition-colors duration-120"
      style={{
        borderColor: seleccionado ? "var(--color-multiva-500)" : "var(--color-border)",
        backgroundColor: seleccionado ? "color-mix(in srgb, var(--color-multiva-600) 8%, transparent)" : "var(--color-background)",
      }}
    >
      <Group justify="space-between" wrap="nowrap">
        <Text size="sm">
          <Text span fw={600}>
            #{proveedor.numeroProveedor}
          </Text>
          {" · "}
          {proveedor.razonSocial}
        </Text>
        <Text size="xs" c="dimmed">
          {proveedor.datosBancarios.banco} · {proveedor.datosBancarios.cuenta}
        </Text>
      </Group>
    </button>
  );
}
